import { Injectable } from '@angular/core';
import { AnalyticsSupabaseService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';
import { ClassInsightsRpcRow } from './class-insights.model';

@Injectable({ providedIn: 'root' })
export class ClassInsightsHttpService {
  constructor(private readonly supabase: AnalyticsSupabaseService) {}

  private readonly schema = 'classroom';

  fetchByClassId(classId: string): Observable<ClassInsightsRpcRow | null> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('get_class_insights', { p_class_id: classId }, { get: true })
        .throwOnError()
        .then((response) => response.data?.[0] ?? null),
    );
  }
}
